import React, {useMemo} from 'react';
import {Button, Card} from "react-bootstrap";
import {NumberUtil} from "zavadil-ts-common";

export type LinkWidgetProps = {
	url: string;
	name: string;
	description?: string | null;
	label?: string;
	onJumpToNodeRequested: (id: number) => void;
}

export default function LinkWidget({url, name, description, label, onJumpToNodeRequested}: LinkWidgetProps) {
	const nodeJumpId = useMemo(() => NumberUtil.parseNumber(url), [url]);
	const actualUrl = useMemo(
		() => {
			if (nodeJumpId !== null) return '';
			return url.startsWith('http://') || url.startsWith('https://') ? url : 'http://' + url;
		},
		[nodeJumpId, url]
	);

	return <Card className="my-3">
		<Card.Body>
			<strong className="card-title">{name}</strong>
			<div className="card-text">{description}</div>
			{
				nodeJumpId ? <Button size="sm" onClick={() => onJumpToNodeRequested(nodeJumpId)}>Pokračovat tudy</Button>
					: <a className="btn btn-primary btn-sm" href={actualUrl} target="_blank">
						{label || 'Otevřít odkaz'}
					</a>
			}
		</Card.Body>
	</Card>
}
